import { BaseDataModel } from "@domain/BaseDataModel";

/** Verified at runtime against the wire format from API.Data.Robots.byIdWithDetail — every field
 *  except `timestamp`, `latitude`, `longitude`, `azimuth`, `pitch`, `roll`, `seconds`, `status`,
 *  `height`, `expiration` is camelCased by the backend's Pydantic-to-JSON serialization. */
export interface RobotRaw {
	timestamp: number;
	azimuth: string;
	currentJobId: string;
	currentMission: string;
	eastVelocity: string;
	northVelocity: string;
	upVelocity: string;
	expiration: number;
	hardwareThrottleReport: string;
	headerFrameId: string;
	headerSeq: number;
	headerStampNsecs: number;
	headerStampSecs: number;
	height: string;
	latitude: string;
	longitude: string;
	missionState: number;
	pitch: string;
	roll: string;
	seconds: string;
	status: string;
}

export interface RobotTimeline {
	type: string;
	start: number;
	end: number;
	designation: string;
	duration: number;
	error: unknown;
	robot: string;
}

export class Robot extends BaseDataModel {
	name!: string;
	latitude!: number;
	longitude!: number;
	lastUpdated?: Date;
	// Invariant: raw is sorted ascending by timestamp; timeline is sorted ascending by start.
	// Sorted once at fetch in RobotsAPI.byIdWithDetail — consumers must not need to re-sort.
	raw?: RobotRaw[];
	timeline?: RobotTimeline[];
}
